import { render, staticRenderFns } from "./Using.vue?vue&type=template&id=dc6c8fa4&scoped=true"
import script from "./Using.vue?vue&type=script&lang=js"
export * from "./Using.vue?vue&type=script&lang=js"
import style0 from "./Using.vue?vue&type=style&index=0&id=dc6c8fa4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc6c8fa4",
  null
  
)

export default component.exports